import { ErrorParams } from '~/error/types';

export class FetchPurchaseUrlError extends Error {
  constructor({ message, options }: ErrorParams) {
    super(message, options);
    this.name = 'FetchPurchaseUrlError';
  }
}
